<!-- <p>rule-details works!</p> -->
<div class="pageContainer">

    <div class="layoutItem">
        <span *ngIf="rule" style="font-size: large; font-weight: bolder;">Rule: {{ rule.RuleDescription }}</span>
        <span class="flex-spacer"></span>
        <button mat-raised-button (click)="back()" style="margin: 0.25em; margin-bottom: 0.5em;" class="app-icon--back">
            <mat-icon/>
            <span>Back</span>
        </button>
    </div>
    <div class="layoutItem" *ngIf="rule && rule.CreatedByUserID">
        <span>Rule Created By: {{rule.CreatedByUserID}}</span>
        <span *ngIf="rule.CreatedAt">&nbsp;on {{getDate(rule.CreatedAt)}}</span>
    </div>
    <div class="layoutItem alignRow">
        <button mat-raised-button color="primary" (click)="OpenRule(rule)" [disabled]="!rule || !asset">
            <span>View Rule</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        <button mat-raised-button color="primary" (click)="goToAsset()" [disabled]="!rule || !asset" class="app-icon--goto">
            <span>Go To Asset</span>
            <mat-icon/>
        </button>
        <mat-icon style="color: salmon;" matTooltip="Delete Rule" (click)="deleteRule()">delete</mat-icon>
        <span class="flex-spacer"></span>
        <button mat-raised-button (click)="goToRules()" style="margin: 0.25em; margin-bottom: 0.5em;">
            <mat-icon>rule</mat-icon>
            <span>All Rules</span>
        </button>
    </div>
    <div class="layoutItem">
        <div class="layoutListItem">
            <div class="title" *ngIf="rule">
                <span>Event History</span>
            </div>
            <div class="events-list-headings">
                <span>Timestamp</span>
                <span>Conditions</span>
                <span>Values</span>
            </div>
            <div class="listbox-container">
                <ejs-listbox [dataSource]='filteredRuleEvents' [fields]="fields" cssClass='e-list-template'
                    [allowFiltering]="true" filterBarPlaceholder="Search for an Event" filterType="contains"
                    (filtering)="onFiltering($event)">
                    <ng-template #itemTemplate let-data>
                        <div class="events-list-items ejs-listbox-item">
                            <span style="font-weight: bolder;">{{ getDate(data.TimeStamp) }}</span>
                            <span> {{ data.RuleText }}</span>
                            <span>{{ data.RuleValues }}</span>
                            <button mat-raised-button (click)="GoToEvent(data)" class="app-icon--goto">
                                <mat-icon/>
                                <span>View Event</span>
                            </button>
                        </div>
                    </ng-template>
                </ejs-listbox>
            </div>
        </div>
        <div class="layoutListItem">
            <div class="title" *ngIf="rule">
                <span>Edit History</span>
            </div>
            <div class="history-list-headings">
                <span>Previous Conditions</span>
                <span>New Conditions</span>
                <span>User</span>
                <span>Timestamp</span>
            </div>
            <div class="listbox-container">
                <ejs-listbox [dataSource]='ruleEdits' cssClass='e-list-template' height='100%'>
                    <ng-template #itemTemplate let-dataSource>

                        <div class="alignRow alignColumn" style="font-weight: bold;"
                            *ngIf="dataSource.PreviousEnabled != dataSource.NewEnabled">
                            <span *ngIf="dataSource.PreviousEnabled == true && dataSource.NewEnabled == false"
                                style="color: lightsalmon;">
                                Rule Disabled
                            </span>
                            <span *ngIf="dataSource.PreviousEnabled == false && dataSource.NewEnabled == true"
                                style="color: lightgreen;">
                                Rule Enabled
                            </span>
                        </div>

                        <div class="alignRow alignColumn" style="font-weight: bold;"
                            *ngIf="dataSource.PreviousCMMSEnabled != dataSource.NewCMMSEnabled">
                            <span *ngIf="dataSource.PreviousCMMSEnabled == true && dataSource.NewCMMSEnabled == false"
                                style="color: lightsalmon;">
                                CMMS Disabled
                            </span>
                            <span *ngIf="dataSource.PreviousCMMSEnabled == false && dataSource.NewCMMSEnabled == true"
                                style="color: lightgreen;">
                                CMMS Enabled
                            </span>
                        </div>

                        <div class="ejs-listbox-item history-list-items">
                            <span>{{ dataSource.PreviousConditions }}</span>
                            <span>{{ dataSource.NewConditions }}</span>
                            <span>{{ dataSource.UserID}}</span>
                            <span style="font-weight: bolder;">{{ getDate(dataSource.Timestamp) }}</span>
                        </div>
                    </ng-template>
                </ejs-listbox>
            </div>
        </div>
    </div>
</div>